import React, { useEffect, useState } from "react";

import MasterInput from "./MasterInput";
import { FormService, showErrorAlert } from "./Form2.service";
import { showSuccessAlert } from "./Form1.service";

import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import form1 from "./Form1";

function AdmissionForm({ course, studentInformation,type }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [step, setStep] = useState(Object.keys(form1)[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(
    JSON.parse(localStorage.getItem("courseFormV") || "{}")
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const addQueryParam = (val) => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      subject_group: val,
    });
  };

  useEffect(() => {
    //please select all subjects error
    const {
      first_major_subject: s1,
      second_major_subject: s2,
      minor_subject: s3,
    } = formData;

    if (window.location.toString().split("/")[4] === "bsc") {
      //check for first subject
      if (["Zoology", "Botany", "Chemistry"].includes(s1)) {
        addQueryParam("ZBC");
      } else {
        addQueryParam("PCM");
      }
    }

    //if(s1 == s2 &&  !(s1==undefined || s1==''))
    if (
      (s1 === s2 && !(s2 === undefined || s2 === "")) ||
      (s1 === s3 && !(s1 === undefined || s1 === "")) ||
      (s2 === s3 && !(s2 === undefined || s2 === ""))
    ) {
     
    }
  }, [
    formData.first_major_subject,
    formData.second_major_subject,
    formData.minor_subject,
  ]);

  useEffect(() => {
    if (formData.same_as_correspondence === "yes") {
      setFormData((prev) => ({
        ...prev,
        p_address: formData.c_address,
      }));
    } else {
    }
  }, [formData.same_as_correspondence, formData.c_address]);

  useEffect(() => {
    const max1 = parseFloat(formData.intermediate_maxmarks);
    const obt1 = parseFloat(formData.intermediate_obtmarks);

    if (!isNaN(max1) && !isNaN(obt1) && max1 > 0) {
      const percentage = ((obt1 / max1) * 100).toFixed(2);
      setFormData((prev) => ({
        ...prev,
        intermediate_percentage: percentage,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        intermediate_percentage: "",
      }));
    }
  }, [formData.intermediate_maxmarks, formData.intermediate_obtmarks]);

  useEffect(() => {
    const max = parseFloat(formData.high_school_maxmarks);
    const obt = parseFloat(formData.high_school_obtmarks);

    if (!isNaN(max) && !isNaN(obt) && max > 0) {
      const percentage = ((obt / max) * 100).toFixed(2);
      setFormData((prev) => ({
        ...prev,
        high_school_percentage: percentage,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        high_school_percentage: "",
      }));
    }
  }, [formData.high_school_maxmarks, formData.high_school_obtmarks]);

    useEffect(() => {
    const max = parseFloat(formData.other_maxmarks);
    const obt = parseFloat(formData.other_obtmarks);

    if (!isNaN(max) && !isNaN(obt) && max > 0) {
      const percentage = ((obt / max) * 100).toFixed(2);
      setFormData((prev) => ({
        ...prev,
        other_percentage: percentage,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        other_percentage: "",
      }));
    }
  }, [formData.other_maxmarks, formData.other_maxmarks]);

    useEffect(() => {
    const max = parseFloat(formData.ug_maxmarks);
    const obt = parseFloat(formData.ug_obtmarks);

    if (!isNaN(max) && !isNaN(obt) && max > 0) {
      const percentage = ((obt / max) * 100).toFixed(2);
      setFormData((prev) => ({
        ...prev,
        ug_percentage: percentage,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        ug_percentage: "",
      }));
    }
  }, [formData.ug_maxmarks, formData.ug_obtmarks]);

  const navigate = useNavigate();

  const handleSubmit = async () => {
     if (isSubmitting) return;




    if (studentInformation.is_admission_fee_payed === true) {
      console.log("Redirecting to dashboard");
      navigate("/student/dashboard", { replace: true });
      return;
    }

    setIsSubmitting(true);

    // console.log("kdhsfehwfiow", studentInformation);
    // setIsLoading(true);
    const response = await FormService.submitForm(formData, course);
    setIsLoading(false);
    if (response.response === false) {
      // console.log("nahi yaya");
      setValidationError(response.errors);
      showErrorAlert(response.message);
      setIsSubmitting(false); 
    } else {
     
    
      showSuccessAlert(response.message);
       window.location.href = "/student/dashboard/";
      localStorage.setItem("admission_code", response.admission_code);
      localStorage.removeItem("courseFormV");
      setIsSubmitting(false);
    }

    return;
  };

  function countSubsetMatches(subset, superset) {
    return subset.filter((val) => superset.includes(val)).length;
  }

  useEffect(() => {
    const courseName = localStorage.getItem("courseFormV") || "{}";
    const courseData = JSON.parse(courseName);

    // Set urn to 0 if studentInformation.refrence_roll is null or undefined
    courseData["applicant_name"] = studentInformation.name;
    courseData["email"] = studentInformation.email;
    if (studentInformation.gender === "M") {
      courseData["gender"] = "male";
    }
    if (studentInformation.gender === "F") {
      courseData["gender"] = "female";
    }
    if (studentInformation.gender === "O") {
      courseData["gender"] = "other";
    }
    courseData["category"] = studentInformation.category;
    localStorage.setItem("courseFormV", JSON.stringify(courseData));
    setFormData(courseData);
  }, [studentInformation]);

  const handleChange = (e, field) => {
    const courseName = localStorage.getItem("courseFormV") || "{}";
    const courseData = JSON.parse(courseName);
    const { name, value, files, type, checked } = e.target;
    const baseName = name.replace("[]", "");

    if (name === "image" || name === "signature") {
      courseData[name] = files[0]?.name || "";
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else if (type === "checkbox") {
      if (field && Array.isArray(field.values)) {
        // Multi-checkbox
        const existing = Array.isArray(formData[baseName]) ? formData[baseName] : [];
        let updated;
        if (checked) {
          updated = existing.includes(value) ? existing : [...existing, value];
        } else {
          updated = existing.filter((v) => v !== value);
        }
        courseData[baseName] = updated;
        setFormData((prev) => ({ ...prev, [baseName]: updated }));
      } else {
        // Single checkbox
        courseData[name] = checked;
        setFormData((prev) => ({ ...prev, [name]: checked }));
      }
    } else {
      courseData[name] = value;
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    localStorage.setItem("courseFormV", JSON.stringify(courseData));
  };

  const [validationError, setValidationError] = useState({});

  const handleNext = () => {
    const keys = Object.keys(form1);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i] === step) {
        setStep(keys[i + 1]);
      }
    }
  };
  const handlePrev = () => {
    const keys = Object.keys(form1);
    const stepsLength = keys.length;
    for (let i = 0; i < keys.length; i++) {
      if (keys[i] === step) {
        setStep(keys[i - 1]);
      }
    }
  };

  const isSubmitted = false;




  return (
    <>
      <div className="multi-step-form-container">

        {/* <h1 onClick={()=>console.log(JSON.parse(localStorage.getItem("courseFormV")))}>Datat dekho</h1> */}
        <div className="progress-bar-23">
          {Object.keys(form1).map((section, index) => (
            <div key={index}>
              <div
                className={`progress-step ${step === section ? "active" : ""} ${
                  isSubmitted ? "disabled" : ""
                } ${
                  countSubsetMatches(
                    Object.keys(validationError),
                    form1[section].map((m) => (m.name || "").replace("[]", ""))
                  ) > 0
                    ? "has-error"
                    : ""
                }`}
                onClick={() => {
                  setStep(section);
                }}
              >
                <div
                  className="step-number"
                  style={{ textTransform: "capitalize" }}
                >
                  {section.split("_")[0]}
                  {countSubsetMatches(
                    Object.keys(validationError),
                    form1[section].map((m) => (m.name || "").replace("[]", ""))
                  ) > 0 ? (
                    <span className="rounded">
                      {" "}
                      {countSubsetMatches(
                        Object.keys(validationError),
                        form1[section].map((m) =>
                          (m.name || "").replace("[]", "")
                        )
                      )}{" "}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Form HEre  */}
        {/* <p>Validation Errors {Object.keys(validationError).length}</p> */}
        <div className="main-form">
          <div className="form-section">
            <h2>
              Part {Object.keys(form1).findIndex((k) => k === step) + 1}:{" "}
              <span style={{ textTransform: "capitalize" }}>
                {step.replace("_", " ")}
              </span>{" "}
            </h2>
          </div>

          <form onSubmit={() => {}} className="form-23">
            {form1[step].map((i) => (
              <MasterInput
                field={i}
                studentInformation={studentInformation}
                formData={formData}
                handleChange={handleChange}
                validationError={validationError}
              />
            ))}
          </form>

          <div className="buttons-box">
            <div className="section-count" style={{ fontWeight: "normal" }}>
              Step {Object.keys(form1).findIndex((k) => k === step) + 1} of 6
            </div>
            <div>
              {step !== Object.keys(form1)[Object.keys(form1).length - 1] &&
                step !== Object.keys(form1)[0] && (
                  <button
                    type="button"
                    className="btn btn-previous"
                    onClick={() => {
                      handlePrev();
                    }}
                    disabled={isLoading}
                  >
                    Previous
                  </button>
                )}

              {step < 6 ? (
                <button
                  type="button"
                  className="btn btn-next"
                  onClick={handleNext}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Next"}
                </button>
              ) : Object.keys(form1)[Object.keys(form1).length - 1] === step ? (
                <>
                  <button
                    type="button"
                    className="btn btn-previous"
                    onClick={() => {
                      handlePrev();
                    }}
                    disabled={isLoading || isSubmitting} 
                  >
                    Previous
                  </button>
                  <button
                    onClick={() => handleSubmit()}
                    type="submit"
                    className="btn btn-submit"
                    disabled={!formData.agreed_to_declaration || isLoading || isSubmitting}
                  >
                    {isLoading ? "Submitting..." : "Submit"}
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  onClick={handleNext}
                  className="btn btn-submit"
                  disabled={isLoading || isSubmitting}
                >
                  {isLoading ? "Saving." : "Next"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdmissionForm;
